/**
 * Live preview of quote line maths in the editor. Mirrors the server engine
 * (backend/app/quotes/pricing.py): half-up rounding to paise per line. The server
 * recomputes on save and is the source of truth; this only keeps the screen responsive.
 */
export interface DraftLine { quantity: number; unit_price: number; discount_pct: number; tax_rate: number }

const round2 = (n: number) => Math.sign(n) * Math.round((Math.abs(n) + Number.EPSILON) * 100) / 100;

export function lineMath(l: DraftLine) {
  const gross = round2(l.quantity * l.unit_price);
  const discount = round2((gross * l.discount_pct) / 100);
  const net = round2(gross - discount);
  const tax = round2((net * l.tax_rate) / 100);
  return { gross, discount, net, tax, total: round2(net + tax) };
}

export function totals(lines: DraftLine[]) {
  return lines.map(lineMath).reduce(
    (t, l) => ({ gross: round2(t.gross + l.gross), discount: round2(t.discount + l.discount), net: round2(t.net + l.net),
      tax: round2(t.tax + l.tax), total: round2(t.total + l.total) }),
    { gross: 0, discount: 0, net: 0, tax: 0, total: 0 },
  );
}
